export class OfflineIndicator {
  private element: HTMLElement;
  private visible = false;

  constructor() {
    this.element = document.createElement('div');
    this.element.className = 'offline-indicator';
    this.element.innerHTML = `
      <span class="offline-dot"></span>
      <span class="offline-text">Reconnecting...</span>
    `;
    this.element.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%) translateY(60px);
      background: rgba(20, 20, 20, 0.95);
      border: 1px solid #333;
      border-radius: 24px;
      padding: 8px 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: system-ui, sans-serif;
      font-size: 13px;
      color: #e0e0e0;
      backdrop-filter: blur(10px);
      transition: transform 0.3s ease;
      z-index: 1000;
    `;

    const dot = this.element.querySelector('.offline-dot') as HTMLElement;
    dot.style.cssText = `
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #ff6b6b;
      animation: pulse 1.5s infinite;
    `;

    // Add pulse animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.4; }
      }
    `;
    document.head.appendChild(style);

    document.body.appendChild(this.element);
  }

  show(): void {
    if (this.visible) return;
    this.visible = true;
    this.element.style.transform = 'translateX(-50%) translateY(0)';
  }

  hide(): void {
    if (!this.visible) return;
    this.visible = false;
    this.element.style.transform = 'translateX(-50%) translateY(60px)';
  }
}
